/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ fileType: NonNullable<unknown> }} Spaces_File_Load_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to load {fileType}" |
*
* @param {Spaces_File_Load_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_file_load_error = /** @type {((inputs: Spaces_File_Load_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_File_Load_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Fehler beim Laden von ${i?.fileType}`)
	return /** @type {LocalizedString} */ (`Failed to load ${i?.fileType}`)
});